import React, { Component } from 'react';
// import { Redirect } from "react-router-dom";
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Input } from 'react-materialize';
import * as actions from '../redux/actions';
import { connect } from 'react-redux';

import Logger from '../functions/logging';

import apiResetPassword from '../api/resetPassword';

import * as auth from '../functions/auth';

import whiteLogo from '../assets/landing/pilotly-logo-white.png';

import PageLoader from '../components/global/PageLoader';

import localeMessages from '../locales/login';
import registerLocaleMessages from '../locales/register';

import '../static/pilotly.css';
import '../static/Login.css';

/* Google analytics */
import SessionStatus from '../analytics/analytics-events/SessionStatus';
import { SessionStatusEvent } from '../analytics/analytics-events/constants';

class ResetPassword extends Component {
	constructor(props) {
		super(props);

		this.state = {
			fields: {
				password: '',
				reenterPassword: ''
			},
			loading: false,
			redirect: false,
			errors: {},
			success: false
		};

		this.validate     = this.validate.bind(this);
		this.submit       = this.submit.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	componentWillMount() {
		if (!this.props.location.search) {
			this.setState({ errors: { reason: 'Email link is invalid' } });
		} else {
			this.parseUrl(this.props.location.search);
		}
	}

	parseUrl(url) {
		const fields = { ...fields };
		const splitUrl = decodeURIComponent(url).split('&');
		const parsedUrl = {};

		splitUrl.forEach(item => {
			let splitItems = item.replace('?', '').split('=');
			parsedUrl[splitItems[0]] = splitItems[1];
		});

		fields.email = parsedUrl.email;
		fields.fhash = parsedUrl.fhash;
		this.setState({ fields });
	}

	dismissError() {
		this.setState({ errors: {} });
	}

	handleChange(event) {
		let key = event.target.name;
		let value = event.target.value;

		let fields = { ...this.state.fields };
		fields[key] = value;

		Logger.log(this.constructor.name, "handleChange()", key, value);

		this.setState({
			fields: fields,
			errors: {}
		});
	}

	validate() {
		let fields = { ...this.state.fields };
		let errors = {};

		const validPasswordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!$%@#£€*?&]{8,}$/;

		if (!fields.password) {
			errors['password'] = this.props.intl.formatMessage(localeMessages.login_error_password_missing);
		} else if (!validPasswordPattern.test(fields.password)) {
			errors['password'] = this.props.intl.formatMessage(registerLocaleMessages.error_password_invalid);
		}
		else if (!fields.password_confirm) {
			errors['password_confirm'] = this.props.intl.formatMessage(localeMessages.login_error_password_missing);
		}
		else if (fields.password !== fields.password_confirm) {
			errors['password_match'] = this.props.intl.formatMessage(localeMessages.reset_error_password_mismatch);
		}

		return Object.keys(errors).length ? errors : false;
	}

	hasErrors() {
		return Object.keys(this.state.errors).length ? true : false;
	}

	getError() {
		const errorKeys = Object.keys(this.state.errors);

		if (errorKeys.length) {
			return this.state.errors[errorKeys[0]];
		}
		return "";
	}

	submit(event) {
		event.preventDefault();

		let fields = { ...this.state.fields };

		let errors = this.validate(fields);
		if (errors) {
			this.setState({ errors: errors });
			return;
		}

		this.setState({ loading: true, errors: {} }, () => {
			this.resetPassword(fields);
		});
	}

	async resetPassword(fields) {
		Logger.log(this.constructor.name, "resetPassword()", (fields ? fields.email : null));
		/* Google analytics event */
		let sessionStatus = new SessionStatus(SessionStatusEvent.AUTH_RESET_PASSWORD, '', '', false, false, true);
		sessionStatus.gaTracker = this.props.tracker;
		sessionStatus.state = 'start';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);

		try {
			const result = await apiResetPassword(fields.email, fields.password, fields.fhash);

			if (result) {
				Logger.log(this.constructor.name, "resetPassword() Successful", result);
				this.setState(() => ({
					redirect: true
				}));

				/* Google analytics event */
				let sessionStatus = new SessionStatus(SessionStatusEvent.AUTH_RESET_PASSWORD, '', '', false, false, true);
				sessionStatus.gaTracker = this.props.tracker;
				sessionStatus.state = 'finish';
				this.props.globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);

			} else {
				Logger.log(this.constructor.name, "resetPassword() request Failed: No result");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.reset_password_error_failed);
				this.setState({
					errors,
					loading: false
				});

				/* Google analytics event */
				let sessionStatus = new SessionStatus(SessionStatusEvent.AUTH_RESET_PASSWORD, '', '', false, false, true);
				sessionStatus.gaTracker = this.props.tracker;
				sessionStatus.state = 'fail';
				this.props.globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "resetPassword() request Failed error", error);
			errors["reason"] = this.props.intl.formatMessage(localeMessages.reset_password_error_failed);
			this.setState({
				errors,
				loading: false
			});
		}
	}

	render() {
		Logger.log(this.constructor.name, "render()", this.props, this.state);

		if (this.state.redirect) {
			Logger.log(this.constructor.name, "render() redirect");
			this.props.history.push('/home');
			return null;
		}

		return (
			<div className="pilotly-login">
				<PageLoader addedClass="pilotly-blue-background" loading={this.state.loading} small={true} />
				<div className="pilotly-login-header">
					<a href="/"><img className="pilotly-login-header-logo" src={whiteLogo} alt="pilotly"/></a>
				</div>
				<div className="pilotly-login-container">
					<div className="pilotly-login-content">
						<h1 className="pilotly-login-title">
							<FormattedMessage
								id="password.reset.title"
								defaultMessage={"Let's Get You a New Password"}
							/>
						</h1>
						<h2 className="pilotly-login-subtitle">
							<FormattedMessage
								id="password.reset.sub-title"
								defaultMessage={"Enter your new password."}
							/>
						</h2>
						<form className="pilotly-login-form pilotly-login-inner" onSubmit={this.submit}>
							<div className={"pilotly-login-alert pilotly-login-alert-error" + (this.hasErrors() ? "" : " display-none")}>
								<p>
									<strong>
										{this.getError()}
									</strong>
								</p>
							</div>

							<div className="">
								<Input name="password"
									type="password"
									label={this.props.intl.formatMessage(localeMessages.password)}
									value={this.state.fields.password}
									onChange={(e) => this.handleChange(e)}>
								</Input>
								{/* <p className="error-text" style={{ display: this.state.errors.password ? "block" : "none" }}>
									{this.state.errors.password ? this.state.errors.password : ""}
								</p> */}
							</div>

							<span className="field-no-status"></span>

							<div className="">
								<Input name="password_confirm"
									type="password"
									label={this.props.intl.formatMessage(localeMessages.reset_password_confirm)}
									value={this.state.fields.password_confirm}
									onChange={(e) => this.handleChange(e)}>
								</Input>
								{/* <p className="error-text" style={{ display: this.state.errors.password_confirm ? "block" : "none" }}>
									{this.state.errors.password_confirm ? this.state.errors.password_confirm : ""}
								</p> */}
							</div>

							<div className="form-input form-input--button">
								<Button tabIndex="3" className="buttonViewX buttonView--defaultX buttonView--primaryX buttonView--largeX button-submitX"
									onClick={this.submit}>
									<FormattedMessage
										id="password.reset.button.submit"
										defaultMessage={"Reset Password"}
									/>
								</Button>
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	tracker: state.GlobalAnalyticsAdapterReducer.gaTracker,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,	
});

export default connect(mapStateToProps, actions)(injectIntl(ResetPassword));



// WEBPACK FOOTER //
// ./src/pages/ResetPassword.js